import { types } from 'mobx-state-tree';
import Actions from './Actions';
import Views from './Views';
import { COMMUNITY_STATUS } from './constants';
const Community = types
    .model({
    status: types.optional(types.enumeration(Object.values(COMMUNITY_STATUS)), COMMUNITY_STATUS.COMMUNITY_IRRELEVANT),
    isOutlookDesktopConnected: types.optional(types.boolean, false),
    isLoaded: types.optional(types.boolean, false),
    isComposeEnabled: types.optional(types.boolean, false),
    isCommunityTermsAccepted: types.optional(types.boolean, false),
    displayFirstShowBanner: types.optional(types.boolean, false),
    firstCommunityTabVisit: types.maybeNull(types.string),
    inviteDismissCount: types.optional(types.number, 0),
    inviteNextAppearance: types.maybeNull(types.string),
    reminderDismissCount: types.optional(types.number, 0),
    reminderNextAppearance: types.maybeNull(types.string),
    isOutlookSettingsLoaded: types.optional(types.boolean, false),
    segment: types.optional(types.string, ''),
    outlookExeDownloadDate: types.optional(types.string, ''),
    isBannerDisplayed: types.optional(types.boolean, false),
    sourceValidationStatus: types.maybeNull(types.string),
})
    .views(Views)
    .actions(Actions);
export default Community;
